import { render } from "./Employee-Thumbnail.vue?vue&type=template&id=95339e08&scoped=true"
import script from "./Employee-Thumbnail.vue?vue&type=script&lang=js"
export * from "./Employee-Thumbnail.vue?vue&type=script&lang=js"

import "./Employee-Thumbnail.vue?vue&type=style&index=0&id=95339e08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95339e08"]])

export default __exports__